// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XPQ1","importantInfo":"styles_importantInfo__2Zz9V"};